/**
 * @engine/vfx — VFX data types + implicit-conversion tables.
 */

/**
 * Data types supported in VFX graphs.
 */
export type VFXDataType =
  // Scalar
  | 'bool'
  | 'int'
  | 'uint'
  | 'float'
  // Vector
  | 'vec2'
  | 'vec3'
  | 'vec4'
  // Color
  | 'color'       // vec4 with color picker
  // Matrix
  | 'mat3'
  | 'mat4'
  // Special
  | 'texture2d'
  | 'texture3d'
  | 'pointmap'    // Point map for particle spawning
  | 'gradient'
  | 'curve'
  // Flow (execution)
  | 'flow'
  // Events (context connections)
  | 'event'       // Generic event input
  | 'spawnEvent'  // Spawn event output
  // Particle data (GPU)
  | 'particle';

/**
 * Implicit type conversions allowed in VFX graphs.
 */
export const VFX_IMPLICIT_CONVERSIONS: ReadonlyMap<VFXDataType, readonly VFXDataType[]> = new Map([
  ['float', ['int', 'uint']],
  ['vec2', ['float']],
  ['vec3', ['float', 'vec2']],
  ['vec4', ['float', 'vec2', 'vec3', 'color']],
  ['color', ['vec3', 'vec4']],
]);

/**
 * Numeric types for auto-promotion.
 */
export const VFX_NUMERIC_TYPES: ReadonlySet<VFXDataType> = new Set([
  'int', 'uint', 'float', 'vec2', 'vec3', 'vec4',
]);
